(() => {
  // A theme-preview fallback and the app block may both load this asset.
  if (window.FramewerkCombinedListingScroll) return;
  const instances = new Map();
  let nextId = 0;
  let scheduled = false;

  function mount(listing) {
    const grid = listing.querySelector(':scope > .fwpo-product-grid');
    if (!grid) return;
    const existing = instances.get(listing);
    if (existing?.grid === grid) {
      existing.update();
      return;
    }
    existing?.destroy();
    const title = listing.querySelector('.fwpo-listing__title');
    const label = listing.getAttribute('aria-label') || 'Related products';
    const header = document.createElement('div');
    header.className = 'fwpo-listing__header';
    const controls = document.createElement('div');
    controls.className = 'fwpo-listing__controls';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', `Scroll ${label}`);
    controls.hidden = true;
    if (!grid.id) grid.id = `fwpo-listing-row-${++nextId}`;
    const buttons = [-1, 1].map((direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fwpo-listing__scroll';
      button.setAttribute('aria-label', `Scroll ${label} ${direction < 0 ? 'left' : 'right'}`);
      button.setAttribute('aria-controls', grid.id);
      button.innerHTML = `<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="${direction < 0 ? 'M14 5l-7 7 7 7' : 'M10 5l7 7-7 7'}" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      button.addEventListener('click', () => {
        const card = grid.querySelector('.fwpo-product-card');
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        const step = (card?.getBoundingClientRect().width || grid.clientWidth * .8) + gap;
        grid.scrollBy({ left: direction * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      controls.append(button);
      return button;
    });
    let updateFrame = 0;
    function scheduleUpdate() {
      if (!updateFrame) updateFrame = requestAnimationFrame(update);
    }
    function update() {
      updateFrame = 0;
      const maximum = Math.max(0, grid.scrollWidth - grid.clientWidth);
      const rtl = getComputedStyle(grid).direction === 'rtl';
      const position = Math.max(0, Math.min(maximum, rtl ? maximum + grid.scrollLeft : grid.scrollLeft));
      if (controls.hidden !== (maximum <= 2)) controls.hidden = maximum <= 2;
      if (buttons[0].disabled !== (position <= 2)) buttons[0].disabled = position <= 2;
      if (buttons[1].disabled !== (position >= maximum - 2)) buttons[1].disabled = position >= maximum - 2;
    }
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleUpdate) : null;
    function destroy() {
      resize?.disconnect();
      cancelAnimationFrame(updateFrame);
      grid.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      // Preserve the existing heading when a mounted row is replaced.
      if (title?.parentElement === header) header.before(title);
      header.remove();
      instances.delete(listing);
    }
    instances.set(listing, { grid, update: scheduleUpdate, destroy });
    grid.before(header);
    if (title) header.append(title);
    header.append(controls);
    grid.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    resize?.observe(grid);
    for (const card of grid.children) resize?.observe(card);
    update();
  }

  function refresh() {
    scheduled = false;
    for (const [listing, instance] of instances) {
      if (!listing.isConnected || !instance.grid.isConnected) instance.destroy();
    }
    document.querySelectorAll('.fwpo-root .fwpo-listing').forEach(mount);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }
  window.FramewerkCombinedListingScroll = { refresh };
  function boot() {
    refresh();
    // Combined listings are inserted asynchronously and can be replaced by the
    // theme editor. Observe structure only, not our disabled/hidden attributes.
    new MutationObserver(records => {
      const structural = '.fwpo-root, .fwpo-listing, .fwpo-product-grid';
      const relevant = records.some(record =>
        record.target instanceof Element && record.target.closest('.fwpo-product-grid') ||
        [...record.addedNodes, ...record.removedNodes].some(node =>
          node instanceof Element && (node.matches(structural) || node.querySelector(structural))
        )
      );
      if (relevant) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
